import * as React from "react";
import {
  CategoryDetailResult,
  FilterQuery,
  ProductResult,
} from "../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import styles from "./category_headline.module.sass";
import { CategoryDescription } from "./category_description";
import { Bestsellers } from "./bestsellers";

export type CategoryHeadlineItem = {
  category: CategoryDetailResult;
  bestsellers: ProductResult[];
  appliedSeoUrlFilters: { brandId: Array<number> };
  categorySeoAttributes: { description: string; name: string };
  pagination: { currentPage: number };
};

export const CategoryHeadline = ({
  category,
  bestsellers,
  appliedSeoUrlFilters,
  categorySeoAttributes,
  pagination,
}: CategoryHeadlineItem): JSX.Element => {
  const landingPageDescription = (
    <div id="category-description">
      <div
        dangerouslySetInnerHTML={{ __html: categorySeoAttributes.description }}
      ></div>
    </div>
  );

  const paginationDescription = (
    <div id="category-description" style={{ fontSize: 18 }}>
      Strana {pagination.currentPage}
    </div>
  );

  const description = Object.keys(appliedSeoUrlFilters).length ? (
    pagination.currentPage > 1 ? (
      paginationDescription
    ) : (
      landingPageDescription
    )
  ) : (
    <CategoryDescription category={category} />
  );

  return (
    <>
      <div className={styles.categoryHeadline}>
        <h1>{categorySeoAttributes.name}</h1>
        {category.advisor !== null && (
          <div className={styles.advisor}>
            <a href={category.advisor.linkPath}>{category.advisor.title}</a>
          </div>
        )}
      </div>
      <div className="cleaner">{description}</div>
      <Bestsellers bestsellers={bestsellers}></Bestsellers>
    </>
  );
};
